/**
 * AB Vault customer-portal config — mirrors `spotter/config.ts`'s "not hardcoded inline for
 * no reason" home for anything that varies per-instance in this interface. Only one screen/tab
 * exists today (Candidate Assignment), but `AB_TOP_TABS` is still a list, same as NFL's
 * `SPOTTER_TOP_TABS` — a later AB Vault screen is then a one-line addition here, not a header rewrite.
 */

/** Header wordmark next to `AbLogo` — the PRODUCT name ("Vault"), not the company name (already
 *  baked into the logo image itself, `ab_logo_wht.png`'s "AMERICAN BRIDGE" lockup) — same
 *  logo-is-company / wordmark-is-product split as `SpotterHeader`'s `SpotterMark` icon + "Spotter"
 *  text. Now the same string as the browser tab title (`AB_VAULT_TITLE`, set in `AbHeader.tsx`),
 *  which used to be the company name but was changed to match this wordmark. */
export const AB_WORDMARK = "Vault";

/** The `requirePlugin(interfaceId)` string `apps/customer-api/src/routes/index.ts` gates every
 *  `/api/ab-vault-candidate-assignments/*` route with, and the same id `GET /api/context`'s
 *  `enabledInterfaces` carries — MUST stay in sync (no shared package between the two apps to
 *  import it from). Feeds `useInterfaceAccess`, the single "is this org actually entitled to AB
 *  Vault" check `AbHeader`/`CandidateAssignmentsScreen` use. */
export const AB_VAULT_INTERFACE_ID = "ab-vault-candidate-assignments";

/** Top-level nav tab defs — routes, not local UI state, so `key` is an absolute path. */
export const AB_TOP_TABS = [
  { key: "/ab-vault/candidate-assignments", label: "Candidate Assignment" },
] as const;
